import { ECurrency } from '../repositories/favorites/entities/commercial/MonthlyIncomeSchema';

export function normalizeCurrency(currency: ECurrency): string {
  switch (currency) {
    case ECurrency.Usd:
      return '$';
    case ECurrency.Eur:
      return '€';
    case ECurrency.Rur:
    default:
      return '₽';
  }
}
